"use client"; 

import { useState, useEffect } from 'react'
import { FunnelIcon, MagnifyingGlassIcon } from '@heroicons/react/20/solid'
import FilterBubbles from '../generic/filterBubbles'
import ConnectionsList from './connectionsList'

import { classNames } from '@/lib/helpers'
import AppLogo from '../apps/logo';


export default function SourceConnectionsBlock(
  { app, sourceConnections, options }: 
  { app: any, sourceConnections: any, options: any }
) {

const { chunk } = options
// FILTER PANEL SHOW/HIDE 
const [showFilters, setShowFilters] = useState(false)

// SEARCH TEXT 
const [searchAppText, setSearchAppText] = useState('')

// FILTER CONNECTIONS
const [selectedCategory, setSelectedCategory] = useState<any>(null)


// ITEMS 
const items = sourceConnections

// FILTER CONNECTIONS - filtering items by 1) selectedCategory 2) SelectedSource 3) SearcText 
const categoryFilterItems = getCategoryFilterItems(items)


const [page, setPage] = useState(1)  // Using to load more apps
// const itemsVisible = items?.slice(0, page*chunk)
const [itemsVisible, setItemsVisible] = useState(
  getFilteredItems(items, { selectedCategory, searchAppText, page, chunk })
)  // Using to load more apps
// const itemsVisible = getFilteredItems(items, selectedCategory, searchAppText)?.slice(0, page*chunk)
useEffect(() => {
  // Log the error to an error reporting service
  setItemsVisible(
    getFilteredItems(items, { selectedCategory, searchAppText, page, chunk })
  )  
}, [searchAppText, selectedCategory, page]);

const itemsIds = items?.map(x => x.id)
const itemsIdsUniq = [... new Set(itemsIds)]

return (
  <div>
    {/* <div className="p-9 bg-red-100 text-xs">
      <p>Items Count: {items?.map(x => x.slug)?.length}</p>
      <p>Items Count: {itemsIds?.length}</p>
      <p>items Uniq Count: {itemsIdsUniq.length}</p>
      {JSON.stringify(items?.map(x => x.slug)?.join(", "))}
    </div> */}

    {/* Connections filters - by category and by source */}
    <div className="my-6 bg-gray-100 rounded-md ">
      
      {/* SEARCH BUTTON AND INPUT BLOCK  */}
      {items?.length > chunk && (
        <div className="flex justify-start">
          <div>
            <button
              type="button"
              onClick={ () => setShowFilters(!showFilters) }
              className={classNames(true ? '' : '', 
                "my-3 mx-3 relative inline-flex items-center px-6 py-2 \
                rounded-md border border-gray-300 bg-transparent text-sm font-medium text-gray-700 hover:bg-gray-50 \
                focus:outline-none")}
            >
              <FunnelIcon className="-ml-1 mr-2 h-5 w-5 text-gray-400" aria-hidden="true" />
              <span>{showFilters ? 'Hide' : 'Show'}</span>
              &nbsp;
              <span className="hidden sm:flex">Filters</span>
            </button>                   
          </div>
          
          <div className="">
            <div className=" relative flex items-stretch flex-grow py-3 pr-3">
          
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
              </div>

              <input
                name="search_app_connections"
                id="search_app_connections"
                className="block w-full pl-10 pr-3 py-2 sm:text-sm border border-gray-300 rounded-md leading-5 bg-white shadow-sm placeholder-gray-500 
                focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-crisp-600 focus:border-crisp-600 " 
                placeholder={`Integrate ${app?.name} with`}              
                onChange={(e) => { setSearchAppText(e.target.value) }}
                onClick={ () => {} }
              />
            </div>


          </div>
        </div>
      )}


      <div className={showFilters ? `` : `hidden`}>
        <div className="">
          {/* border-b border-gray-200 */}
          <FilterBubbles 
            items={categoryFilterItems} 
            selectedItem={selectedCategory} 
            setSelectedItem={setSelectedCategory}             
            filterTitle='' 
            chunk={20}
            chunkInitial={4}
            itemAll = {{ 
              name: 'All Categories', 
              slug: 'all', 
              count: items?.length 
            }}
          />
        </div>
            
      </div>

    </div>



    <div className="space-y-6">
      
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {itemsVisible?.map((a) => (
          <div
            key={a?.slug}
            className=" rounded border border-gray-300 bg-white hover:border-crisp-600/50"
          >
            <div className="relative flex items-center space-x-1.5 pr-1.5">
              
              <div className="p-2  flex-shrink-0">
                <AppLogo app={a} className='w-12 h-12 rounded text-white' />              
              </div>

              <div className=" flex-1 min-w-0">
                <a 
                  href={`/${a?.slug}`} 
                  title={a?.name} 
                  className="focus:outline-none"
                >
                  <span className="absolute inset-0" aria-hidden="true" />
                  <h3 className="text-sm font-medium text-gray-900 line-clamp-2">
                    {a?.name}
                  </h3>
                </a>
              </div>
            </div>
            

          </div>
        ))}
      </div>
      
      {(page*chunk < itemsVisible?.length) && (
        <div 
          className=""
          // className='mx-auto py-6 text-center' 
        >
          <button
            onClick={() => setPage(page + 1)}
            type="button"    
            className="w-full text-center  rounded-full py-3 px-9 text-base leading-6 text-gray-600 ring-1 ring-gray-200 hover:ring-crisp-600/50"
          >
            <span className="font-medium text-gray-800">
              Show more 
            </span>
          </button>
        </div>
      )}
    </div>

  </div>
  )

}


const searchCompare = (searchText: string, itemText: string) => {
  return itemText?.toLowerCase()?.includes(searchText?.toLowerCase())
}


const getCategoryFilterItems = (items) => {  

  // FILTER CONNECTIONS - get categories to filter  
  const categoriesList = items?.map(item => ({ 
    slug: item?.primary_category?.slug, 
    name: item?.primary_category?.name 
  }))?.filter(c => c?.slug)
  const categoriesUnique = Array.from(new Set(categoriesList.map(c => c.slug))).map(slug => {
    return categoriesList.find(c => c.slug === slug)
  })
  const filterItems = categoriesUnique?.map(item => ({
    ...item, 
    count: categoriesList?.filter(c => c.slug === item.slug)?.length
  }))?.sort((a, b) => b.count-a.count)  // Full list of categories  
  return filterItems
}

const getFilteredItems = (items, {
  selectedCategory, 
  searchAppText, 
  page, 
  chunk
}) => {
  const filteredCats = (selectedCategory?.slug==='all' || !selectedCategory) 
    ? items : items?.filter(c => c?.primary_category?.slug === selectedCategory?.slug)
  const itemsFiltered = searchAppText ? filteredCats?.filter(c => searchCompare(searchAppText, c?.name)) : filteredCats
  const itemsSorted = itemsFiltered?.sort((a, b) => ( b.count_connections_published - a.count_connections_published ))
  return itemsSorted?.slice(0, page*chunk)
}